var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5h1.5ZM9.5 4.25a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h6ZM11.75.5a.75.75 0 0 1 0 1.5H1.25a.75.75 0 0 1 0-1.5h10.5Z",
    fill: "#343A40"
  })));
};
export default SvgFilterIcon;